export default __webpack_public_path__ + "static/media/helo.fc048ae8.png";